import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#fff" }) => {
  return (
    <svg
      id="Layer_1"
      version="1.1"
      width={"25px"}
      height={"25px"}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      {" "}
      <style type="text/css"></style>
      <path
        fill={fill}
        d="M381,236H276V131c0-11-9-20-20-20s-20,9-20,20v105H131c-11,0-20,9-20,20s9,20,20,20h105v105c0,11,9,20,20,20  s20-9,20-20V276h105c11,0,20-9,20-20S392,236,381,236z"
      />
    </svg>
  );
};

export default memo(Icon);
